<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <sales-transaction-form :title="title"/>
  </v-container>
</template>

<script>
import SalesTransactionForm from './_Form'
export default {
  name: 'SalesTransactionEdit',
  components: {
    SalesTransactionForm
  },
  mixins: [],
  props: {},
  data() {
    return {
      title: '売上編集',
      breadcrumbs: [
        { text: '売上管理', disabled: false, to: '/driver/sales/transactions', exact: true },
        { text: '売上の編集', disabled: true, to: '' },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {}
}
</script>
